import { useCurrentCompany } from '@/hooks/swr/useCurrentCompany'
import { computed, type ComputedRef } from 'vue'

export const useCurrentCompanyNameKey = (): ComputedRef<string | undefined> => {
  const { data: currentCompany } = useCurrentCompany()
  return computed(() => currentCompany.value?.name_key)
}
